<template>
  <div class="graphic-template">
    <div class="graphic-template__header">
      Archiwum
    </div>

    <div class="graphic-template__content">
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="4"
          xl="3"
        >
          <ProjectCard
            :project="project"
            :deletable="false"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProjectCard from '@/components/Projects/ProjectCard.vue';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  components: {
    ProjectCard,
  },

  computed: {
    ...mapState('project', [
      'project',
    ]),
  },

  created() {
      this.fetchProject(this.id);
  },

  beforeDestroy() {
      this.resetProject();
  },

  methods: {
    ...mapActions('project', [
      'fetchProject',
      'resetProject',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.graphic-template {
  margin-bottom: 16px;

  &__header {
    background: #fff;
    box-shadow: 0px 3px 6px $shadow-key-umbra-opacity;
    margin-bottom: 8px;
    padding: 24px 32px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
  }
}
</style>
